import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { LocationSetTypesActions } from './location-set-types.actions';
import { LocationSetTypesSelectors } from './location-set-types.selectors';
import {AsyncActionQueries, AsyncActionSelectors} from '@emm/core/util/async-action-state';
import {LocationSetType} from '@emm/core/models/location-set-type.model';
import {AsyncActionStoreService} from '@emm/core/store/async-action-store.service';
import {SearchFilter} from '@emm/core/models/search-filter';
import {State as CoreState} from '@emm/core/store/core.reducer';


export interface LocationSetTypesQueries extends AsyncActionQueries {
    all$: Observable<LocationSetType[]>;
    displayResultsImmediately$: Observable<boolean>;
    isLocationSetTypeParent$: Observable<boolean>;
    onlyParents$: Observable<LocationSetType[]>;
    selected$: Observable<LocationSetType>;
}

@Injectable({
    providedIn: 'root'
})
export class ManagementLocationSetTypesStoreService extends AsyncActionStoreService<AsyncActionSelectors> {

    dispatch = {
        selectLocationSetType: (tag: string) =>
            this.store.dispatch(LocationSetTypesActions.select({ tag })),
        searchLocationSetTypes: (filter: SearchFilter) =>
            this.store.dispatch(LocationSetTypesActions.searchLocationSetTypes({ filter })),
        openAddLocationSetTypeDialog: () =>
            this.store.dispatch(LocationSetTypesActions.openAddDialog()),
        deleteLocationSetType: (locationSetType: LocationSetType) =>
            this.store.dispatch(LocationSetTypesActions.delete({ locationSetType })),
        selectLocationSetTypeFromLocationSets: (tag: string) =>
            this.store.dispatch(LocationSetTypesActions.selectFromLocationSets({ tag }))
    };

    queries: LocationSetTypesQueries = {
        all$: this.selectNonNil(LocationSetTypesSelectors.getFilteredLocationSetTypes),
        onlyParents$: this.selectNonNil(LocationSetTypesSelectors.getValidOnlyParents),
        selected$: this.selectNonNil(LocationSetTypesSelectors.getSelected),
        ...this.asyncActionQueries,
        isLocationSetTypeParent$: this.select(LocationSetTypesSelectors.getIsLocationSetTypeParent),
        displayResultsImmediately$: this.selectNonNil(
            LocationSetTypesSelectors.getDisplayResultsImmediately
        )
    };

    constructor(store: Store<CoreState>) {
        super(store, LocationSetTypesSelectors);
    }

}
